<template>
        <div id="admin-submit-form" class="col-12">
          <div v-if="!submitted">
            <p>Aktueller Spieltag: {{ currentMatchDay }}</p>

            <Panel id="p-panel-header-pad" header="Letzte Aktualisierung">
              <p class="m-0">{{ lastChangedDate }}</p>
              <template #icons>
                <button @click="getMatchDayLastChangedDate" class="btn btn-sm m-1">
                  <font-awesome-icon icon="redo-alt"/>
                </button>
              </template>
            </Panel>
            <br/>
            <div class="form-group">
              <label for="title">Spieltag</label>
              <input
                  type="number"
                  class="form-control"
                  id="title"
                  required
                  v-model="matchDayCall.dayNumber"
                  name="title"
              />
            </div>

            <button @click="checkMatchDay" class="btn btn-success m-1">Check Spieltag Status</button>
            <button @click="initMatchDay" class="btn btn-success m-1">Init Spieltagsdaten</button>
            <button @click="updateMatchDay" class="btn btn-success m-1">Update Spieltagsberechnung</button>
            <button @click="updateMatchDayDirect" class="btn btn-success m-1">Update Spieltagsberechnung {{ currentMatchDay }}</button>
          </div>

          <div v-else>
            <h4>You submitted successfully!</h4>
            <button class="btn btn-success" @click="clearMessage">Ok</button>
          </div>

          <div v-if="matches">
            <DataTable :value="matches"
                       resizableColumns columnResizeMode="fit"
                       class="p-datatable-sm p-datatable-striped"
                       :rowClass="rowClass">

              <!-- HOME TEAM NAME -->
              <Column field="team1" header="Heim">
                <template #body="slotProps">
                  <span v-responsive.md.lg.xl.xs class="p-ml-1">{{ slotProps.data.team1 }}</span>
                </template>
              </Column>

              <!-- GUEST TEAM NAME -->
              <Column field="team2" header="Gast">
                <template #body="slotProps">
                  <span v-responsive.md.lg.xl.xs class="p-ml-1">{{ slotProps.data.team2 }}</span>
                </template>
              </Column>

              <!-- SCORE -->
              <Column header="Beendet">
                <template #body="slotProps">
                  <font-awesome-icon  v-if="slotProps.data.finished" icon="check-circle"/>
                </template>
              </Column>

              <!-- Endergebnis angegeben -->
              <Column header="Endergebnis vorhanden">
                <template #body="slotProps">
                  <font-awesome-icon  v-if="slotProps.data.endResultSet" icon="check-circle"/>
                </template>
              </Column>

            </DataTable>
          </div>
        </div>
</template>

<script>
import MatchDataService from "../services/match-data.service";
import MatchDayDataService from "../services/match-day-data.service";

export default {
  name: "init-match-day",
  data() {
    return {
      matchDayCall: {
        id: null,
        dayNumber: this.currentMatchDay,
        seasonYear: this.currentSeasonYear
      },
      lastChangedDate: null,
      submitted: false,
      matches: null
    };
  },
  computed: {
    currentMatchDay() {
      return this.$store.state.sys.matchDay;
    },
    currentSeasonYear() {
      return this.$store.state.sys.seasonYear;
    }
  },
  methods: {
    checkMatchDay() {
      this.matches = null;
      let data = {
        season: this.currentSeasonYear,
        matchDayNumber: this.matchDayCall.dayNumber
      };
      MatchDayDataService.checkMatchDay(data)
          .then(response => {
            console.log(response.data);
            this.matches = response.data.matches;
          })
          .catch(e => {
            console.log(e);
          });
    },
    rowClass(data) {
      return data.finished === true ? 'highlight' : null;
    },
    initMatchDay() {
      var data = {
        dayNumber: this.matchDayCall.dayNumber,
        seasonYear: this.currentSeasonYear
      };

      // console.log("this.currentSeasonYear: " + this.currentSeasonYear);
      MatchDataService.initMatchDay(data)
          .then(response => {
            console.log(response.data);
            this.submitted = true;
          })
          .catch(e => {
            console.log(e);
          });
    },
    updateMatchDay() {
      var data = {
        dayNumber: this.matchDayCall.dayNumber,
        seasonYear: this.currentSeasonYear
      };

      MatchDayDataService.updateMatchDayByApi(data)
          .then(response => {
            console.log(response.data);
            this.submitted = true;
          })
          .catch(e => {
            console.log(e);
          });
    },
    getMatchDayLastChangedDate() {
      this.lastChangedDate = null;
      var data = {
        dayNumber: this.currentMatchDay,
        seasonYear: this.currentSeasonYear
      };
      MatchDayDataService.getMatchDayLastChangedDate(data)
          .then(date => {
            this.lastChangedDate = date.data;
          })
          .catch(e => {
            console.log(e);
          });
    },
    updateMatchDayDirect() {
      var data = {
        dayNumber: this.currentMatchDay,
        seasonYear: this.currentSeasonYear
      };

      MatchDayDataService.updateMatchDayByApi(data)
          .then(response => {
            console.log(response.data);
            this.submitted = true;
          })
          .catch(e => {
            console.log(e);
          });
    },
    clearMessage() {
      this.submitted = false;
      this.matchDayCall = {};
    }
  },
  mounted() {
    this.getMatchDayLastChangedDate();
  }
};
</script>

<style>
#admin-submit-form {
  width: 100% !important;
  //margin: auto;
  padding: 0;
}

.p-grid {
  margin: 0;
}

#p-panel-header-pad .p-panel-content {
  margin: 0;
}
.p-datatable .p-datatable-tbody > tr.p-highlight {
  background: transparent !important;
  color: #000000 !important;
}
.p-datatable .p-datatable-tbody > tr > td {
  font-size: 0.8rem !important;
}
.p-datatable .p-datatable-thead > tr > th {
  font-size: 0.8rem !important;
}

.p-datatable .p-datatable-footer {
  text-align: right !important;
}

.p-datatable .p-rowgroup-header {
  background: #f8f9fa !important;
}

.highlight {
  /* background-color: greenyellow !important; */
  font-weight: bold;
}

.p-accordion .p-accordion-tab:last-child .p-accordion-content {
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  padding: 3px;
}

</style>